import React, { RefObject } from 'react';
import map from 'lodash/map';
import styled from 'styled-components';

// components
import Loader from 'pages/MerchantPages/Assets/Content/components/FormikFields/Panopto/Loader';

// utils
import parsePanoptoValue from 'pages/MerchantPages/Assets/Content/components/utils/parsePanoptoValue';

const StyledIframe = styled.iframe`
  width: 100%;
  margin-bottom: 85px;
  min-height: 85vh;
`;

interface Props {
  formRef: RefObject<HTMLFormElement>;
  isLoading: boolean;
  formdata: Record<string, any>;
  action: string;
  onLoad: () => void;
}

const PanoptoForm = ({ formRef, isLoading, action, formdata, onLoad }: Props) => {
  return (
    <>
      {isLoading && <Loader />}
      <StyledIframe id="videos" width="100%" height="100%" name="videos" title="videos" onLoad={onLoad} />
      <form
        ref={formRef}
        id="ltiLaunchForm"
        name="ltiLaunchForm"
        encType="application/x-www-form-urlencoded"
        method="POST"
        action={action}
        target="videos"
      >
        {map(formdata, (val: any, key: string) => (
          <input type="hidden" name={key} value={parsePanoptoValue(val)} key={key} />
        ))}
      </form>
    </>
  );
};

export default PanoptoForm;
